import { Injectable } from '@angular/core';

import { LimitResponse } from '@bpos/v1/limits';
import { ApiService } from '@frontend/sports/common/api-utils';
import { LoggerFactory, SportsRemoteLogger } from '@frontend/sports/common/core/feature/logging';
import { EMPTY, Observable, catchError } from 'rxjs';

@Injectable()
export class UserStakeLimitsService {
    private readonly logger: SportsRemoteLogger;

    constructor(
        private apiService: ApiService,
        loggerFactory: LoggerFactory,
    ) {
        this.logger = loggerFactory.getLogger('UserStakeLimitsService');
    }

    getUserStakeLimits(): Observable<LimitResponse> {
        return this.apiService.get<LimitResponse>(`StakeLimits`).pipe(
            catchError((error: any) => {
                this.logger.error(error, 'Error while fetching user stake limits');

                return EMPTY;
            }),
        );
    }
}
